module.exports = __webpack_public_path__ + "static/media/accessibility.b6dc3a8e.zip";